export const RecordingSource = {
  HOST: 'host',
  GUEST: 'guest',
  CLIPS: 'clips',
};

export const Pathnames = {
  APPS: '/apps',
  CHANNELS: '/channels',
  CREATEACCOUNT: '/createaccount',
  CREATEPASSWORD: '/createpassword',
  CONNECTION_MANAGER: '/integrations',
  DASHBOARD: '/dashboard',
  JOIN: '/join',
  LOGIN: '/login',
  LOGOUT: '/logout',
  PLAYERS: '/players',
  RECORDINGS: '/recordings',
  RESETPASSWORD: '/resetpassword',
  USERS: '/users',
};

export const ModalTypes = {
  INPUT: 'input',
  CONFIRMATION: 'confirmation',
  INCOMPATIBLE_BROWSER: 'incompatible browser',
};

export const FormValidationErrorMessages = {
  MAX_LENGTH: 'too long',
  EMPTY: 'too short',
};

export const StreamCheckmarkType = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  NONE: '',
};

export const JoinBroadcastLinkType = {
  GUEST: 'Guest',
  BROADCAST: 'Broadcast',
};

export const FileExportFormat = {
  CAPTIONS: 'captions',
  MP3: 'mp3',
  MP4: 'mp4',
  SRT: 'srt',
  TRANSCRIPT: 'transcript',
  VTT: 'vtt',
};

export const FileExportState = {
  COMPLETED: 'completed',
  IN_PROGRESS: 'in-progress',
  FAILED: 'failed',
  NOT_STARTED: 'not-started',
};

export const LearnMoreOption = {
  LEARN_MORE: 'Learn more...',
};
